// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"4454811f","693":"e65a720c","845":"93f255e5"}[chunkId] + ".chunk.js";
};